<template>
  <div class="workbench">
    <!-- <header-show :title="'上海得帆信息技术有限公司'"></header-show> -->
    <div class="header-panel">
      <div class="header-panel-item my-todo" @click="handleHeaderClick('my-todo')">
        <span class="header-count">{{ headerData.todoCount }}</span>
        <span class="header-title">我的待办</span>
      </div>
      <div class="header-panel-item my-submit" @click="handleHeaderClick('my-submit')">
        <span class="header-count">{{ headerData.submitCount }}</span>
        <span class="header-title">我的发起</span>
      </div>
      <div class="header-panel-item my-participate" @click="handleHeaderClick('my-participate')">
        <span class="header-count">{{ headerData.participateCount }}</span>
        <span class="header-title">我的已办</span>
      </div>
    </div>
    <div v-if="menuStars && menuStars.length > 0" class="menu-star-panel">
      <div class="menu-star-header">
        <x-svg-icon name="star-function"></x-svg-icon>
        <span class="menu-title-text">星标功能</span>
      </div>
      <div class="menu-star-list">
        <template v-for="menu in menuStars">
          <div :key="menu.menuId" class="menu-star-item" @click="handleEnterMenu(menu)">
            <div class="menu-star-icon" :style="{ 'background-color': menu.appTheme }">
              <x-svg-icon :name="menu.menuIcon"></x-svg-icon>
            </div>
            <span class="menu-star-label text-ellipsis">{{ menu.menuName }}</span>
          </div>
        </template>
      </div>
    </div>
    <div class="app-panel">
      <div v-if="appList && appList.length > 0" class="app-header">
        <x-svg-icon name="app-icon"></x-svg-icon>
        <span class="app-title-text">我的应用</span>
      </div>
      <div v-if="appList && appList.length > 0" class="app-list">
        <div v-for="app in appList" :key="app.id" class="app-box" @click="handleClick(app)">
          <div class="app-icon" :style="{ 'background-color': app.appTheme }">
            <x-svg-icon class="app-icon-svg" :name="app.appIcon || 'system-icon-20'"></x-svg-icon>
          </div>
          <span class="app-title">{{ app.appName }}</span>
        </div>
        <div v-for="(app, idx) in appListEmpty" :key="idx" class="app-box">
          <div class="app-icon">
          </div>
          <span class="app-title"></span>
        </div>
      </div>
      <template v-else>
        <div class="empty-box">
          <x-empty></x-empty>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
// import HeaderShow from '@/components/header-show/index.vue'
import apis from '../../api/index'
import { mapState, mapMutations } from 'vuex'
import { SET_PLATFORM_TYPE } from '@/store/tenant.store.js'
export default {
  name: 'Workbench',
  components: {
    // HeaderShow
  },
  data() {
    return {
      appList: [],
      menuStars: [],
      headerData: {
        todoCount: 0,
        submitCount: 0,
        participateCount: 0
      }
    }
  },
  computed: {
    ...mapState({
      currentOrg: (state) => state.tenantModule.currentOrg
    }),
    appListEmpty() {
      if (this.appList.length % 4 === 1) {
        return new Array(1)
      } else if (this.appList.length % 4 === 2) {
        return new Array(2)
      } else if (this.appList.length % 4 === 3) {
        return new Array(3)
      } else {
        return []
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      window.document.title = vm.currentOrg.name
    })
  },
  created() {
    this.initApps()
    this.setPlatformType(location.search.split('=')[1])
  },
  methods: {
    ...mapMutations('tenantModule', {
      setPlatformType: SET_PLATFORM_TYPE
    }),
    handleHeaderClick(type) {
      this.$router.push({
        name: 'todo-center',
        query: {
          type
        }
      })
    },
    initApps() {
      const request = {
        ...apis.WORKBENCH.QUERY_HOME_LIST
      }

      console.log(request)
      // this.$loading.show()
      this.$request(request)
        .asyncThen(
          (resp) => {
            this.$loading.hide()

            this.appList = (resp.data.appList || []).sort((firstEl, lastEl) => {
              let firstIndex = resp.data.appSortList && resp.data.appSortList.findIndex((appSort) => {
                return appSort === firstEl.id
              })
              let lastIndex = resp.data.appSortList && resp.data.appSortList.findIndex((appSort) => {
                return appSort === lastEl.id
              })

              if (firstIndex === -1) {
                firstIndex = Number.MAX_VALUE
              }

              if (lastIndex === -1) {
                lastIndex = Number.MAX_VALUE
              }

              return firstIndex - lastIndex
            })
            // this.appList = resp.data.appSortList ? resp.data.appSortList.map(appId => {
            //   return (resp.data.appList || []).find(app => app.id === appId)
            // }).filter((app) => {
            //   return app
            // }) : resp.data.appList

            this.menuStars = resp.data.starSortList
              ? resp.data.starSortList
                .map((menuId) => {
                  return (resp.data.starList || []).find((menu) => menu.menuId === menuId)
                })
                .filter((menu) => {
                  return menu
                })
              : resp.data.starList

            this.menuStars = (resp.data.starList || []).sort((firstEl, lastEl) => {
              let firstIndex = resp.data.starSortList && resp.data.starSortList.findIndex((starSort) => {
                return starSort === firstEl.menuId
              })
              let lastIndex = resp.data.starSortList && resp.data.starSortList.findIndex((starSort) => {
                return starSort === lastEl.menuId
              })

              if (firstIndex === -1) {
                firstIndex = Number.MAX_VALUE
              }

              if (lastIndex === -1) {
                lastIndex = Number.MAX_VALUE
              }

              return firstIndex - lastIndex
            })

            for (let key in this.headerData) {
              this.headerData[key] = resp.data[key] || 0
            }
          },
          () => {
            this.$loading.hide()
            this.loadingVisible = false
          }
        )
        .asyncErrorCatch((error) => {
          this.$loading.hide()
          this.loadingVisible = false
          if (error.response.status === 402) {
            this.showVersonOverdue = true
          }
        })
    },
    handleClick(appInfo) {
      console.log(appInfo)
      this.$router.push({
        name: 'appMenu',
        query: {
          title: appInfo.appName,
          appId: appInfo.id
        }
      })
    },
    handleEnterMenu(menu) {
      if (menu.menuType === 'REPORT') {
        this.$router.push({
          name: 'appAnalyse',
          query: {
            title: menu.menuName,
            formId: menu.formId,
            appId: menu.appId,
            currentMenu: menu.menuId
          }
        })
      } else if (menu.menuType === 'MENU') {
        this.$router.push({
          name: 'appList',
          query: {
            title: menu.menuName,
            formId: menu.formId,
            appId: menu.appId,
            processId: menu.processId,
            currentMenu: menu.menuId
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
.workbench {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 3.428rem;
  right: 0;
  background-color: $--app-light-color;
  overflow: auto;
  .header-panel {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 6.285rem;
    margin: 0 1.14rem;
    box-shadow: $--app-box-shadow;
    margin-top: 1.71rem;
    .header-panel-item {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      flex: 1;
      height: 2.857rem;
      border-right: 1px solid $--app-split-line-color;
      &:last-child {
        border-right: 0;
      }
      .header-count {
        font-weight: $--app-base-font-weight;
        font-size: 16px;
      }
      .header-title {
        margin-top: 0.57rem;
        font-size: $--app-base-font-size;
        color: $--app-notice-color;
      }
    }
  }
  .app-header,
  .menu-star-header {
    display: flex;
    align-items: center;
    height: 1.71rem;
    padding: 0 1.14rem;
    line-height: normal;
    .app-title-text,
    .menu-title-text {
      margin-left: 8px;
      font-size: $--app-title-font-size;
      font-weight: $--app-base-font-weight;
    }
    .svg-icon {
      width: 1.285rem !important;
      height: 1.285rem !important;
    }
  }
  .app-panel,
  .menu-star-panel {
    padding-top: 1.71rem;
  }
  .menu-star-list {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    .menu-star-item {
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      align-items: center;
      width: 25%;
      margin-top: 1.428rem;
      .menu-star-icon {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 2.86rem;
        height: 2.86rem;
        border-radius: 50%;
        .x-svg-icon {
          width: 1.428rem !important;
          height: 1.428rem !important;
          .svg-icon {
            width: 100% !important;
            height: 100% !important;
            color: $--app-light-color;
          }
        }
      }
      .menu-star-label {
        text-align: center;
        padding-top: 0.286rem;
        width: calc(100% - 0.57rem * 2);
        font-size: $--app-base-font-size;
      }
    }
  }
  .app-list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
    .app-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      width: 25%;
      margin-top: 1.428rem;
      .app-icon {
        height: 2.86rem;
        width: 2.86rem;
        border-radius: $--app-base-border-radius;
        display: flex;
        justify-content: center;
        align-items: center;
        .x-svg-icon {
          width: 1.428rem !important;
          height: 1.428rem !important;
          .svg-icon {
            width: 100% !important;
            height: 100% !important;
            color: $--app-light-color;
          }
        }
      }
      .app-title {
        text-align: center;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding-top: 0.286rem;
        width: calc(100% - 0.57rem * 2);
        font-size: $--app-base-font-size;
      }
    }
  }
  .empty-box {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
